module.exports = __webpack_public_path__ + "img/avatar.9de5833d.jpg";